import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';
import { useMachineReasonCategoriesDelete } from 'containers/MachineReasonCategories/useDelete';

function MachineReasonCategoriesRoute() {
  const customDelete = useMachineReasonCategoriesDelete();
  return (
    <BaseView
      configuration={baseModuleConfigs['Machine Reason Categories']}
      customDelete={customDelete}
    />
  );
}

export const Route = createFileRoute('/_authenticated/machineReasonCategories')({
  component: MachineReasonCategoriesRoute,
});
